import React from 'react'
import { injectIntl, Link } from 'gatsby-plugin-intl'
import { useStaticQuery, graphql } from 'gatsby'
import styled from 'styled-components'
import { colors, breakpoints } from 'utils/utils'
import { FaLinkedinIn, FaTwitter, FaYoutube } from 'react-icons/fa'
import Img from 'gatsby-image'
import NewsletterFooter from './NewsletterFooter'

export default injectIntl(props => {

const data = useStaticQuery(graphql`
  query{
    allContentfulFooter(filter: {name: {eq: "Footer"} }) {
      edges {
        node {
          node_locale
          menu {
            links {
              id
              value
              href
            }
          }
          copyright
          logos {
            id
            title
            description
            fluid {
              ...GatsbyContentfulFluid_withWebp_noBase64  
            }
          }
          newsletter {
            title
            description
            form {
              formTextField {
                htmlid
                type
                label
                required
              }
              formTextArea {
                  attrName
                  maxlength
                  placeholder
              }
              disclaimer {
                  htmlid
                  text {
                      text
                  }
                  required
              }
              button
              successMessage
              errorMessage
            }
          }
        }
      }
    }
  }
`)

  const Links = data.allContentfulFooter.edges
  .filter( data => data.node.node_locale === props.intl.locale)[0].node.menu.links
  .map(
    link => <li key={link.id}><Link to={`/${props.intl.locale}/${link.href}`}>{link.value}</Link></li>
  )

  const { logos, copyright } = data.allContentfulFooter.edges[0].node
  const copyrightYear = new Date().getFullYear();

  const formNewsletter = data.allContentfulFooter.edges
  .filter( data => data.node.node_locale === props.intl.locale)[0].node.newsletter
  const lang = props.intl.local
  
  return (
    <Footer>        
        <NewsletterFooter form={formNewsletter.form} lang={lang} title={formNewsletter.title} description={formNewsletter.description}/>
        <FooterBlock>
          <div>
            <nav>
              <ul>
                <li>
                  <a 
                    className="social linkedin" 
                    href="https://www.linkedin.com/company/orienteed/"
                    aria-label="Linkedin"
                    target="_blank"
                    rel="noreferrer"
                  >
                  <FaLinkedinIn/>
                  </a>
                </li>
                <li>
                  <a 
                    className="social twitter" 
                    href="https://twitter.com/orienteed?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor"
                    aria-label="Twitter"
                    target="_blank"
                    rel="noreferrer"
                  >
                  <FaTwitter/>
                  </a>
                </li>
                <li>
                  <a 
                    className="social youtube" 
                    href="https://www.youtube.com/channel/UC4p-WfBtaBBil_VF3QB228A"
                    aria-label="YouTube"
                    target="_blank"
                    rel="noreferrer"
                  >
                  <FaYoutube/>
                  </a>
                </li>
                { Links }
              </ul>
            </nav>
          </div>
          <div className="rightSection">
              {
                  logos.map((logo, index) =>
                      <Img fluid={logo.fluid} alt={logo.description} key={index} />
                  )
              }
              <span>{copyright} {copyrightYear}</span>
          </div>
        </FooterBlock>
    </Footer>
  )
})

const FooterBlock = styled.div`
  padding: 1.6rem;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  box-sizing: border-box;
  ${breakpoints.md} {
    justify-content: space-around;
  }
`

const Footer = styled.footer`
  background-color: ${colors.quaternary};
  width:100%;
  

  .rightSection {
    display: flex;
    width: auto;
    color: ${colors.tertiary};
    
    .gatsby-image-wrapper {
      width: 5.2rem;
      height: 3.5rem;
      margin: auto .5rem;
    }
    span {
        display: block;
        margin: auto 2.5rem auto 1rem;
        ${breakpoints.md} {
            margin: auto 0 auto 1rem;
            text-align: center;
        }
        ${breakpoints.sm} {
            font-size: .7rem;
        }
    } 
  }

  ul {
    display: flex;
    list-style: none;
    align-items: center;
    ${breakpoints.md} {
        padding: 0;
    }
    
    li {
      padding: 0 .8rem;
      a{
        &:link, &:visited, &:active{
          font-weight: bold;
          font-size: 1.2rem;
          text-decoration: none;
          color: ${colors.tertiary};
        } 
        &.social {
          display:flex;
          background: rgba(255, 255, 255, 0.1); 
          border-radius: 100%;
          width:48px;
          height: 48px;
          align-items: center;
          justify-content: center;
          svg {
            font-size: 2rem;
          }
          &.twitter:hover {
            background-color: #00AACE;
            transition: background-color .5s;          
          }
          &.linkedin:hover {
            transition: background-color .5s;
            background-color: #007bff;
          }
          &.youtube:hover {
            transition: background-color .5s;
            background-color: #de1f21;
          }
        }
      }
    }
  }

`